import { createFileRoute, redirect } from '@tanstack/react-router';

// DEPRECADO: "Tipos de tenant" (`/platform/tenant-types`) lo reemplazó el modelo data-driven de
// Aplicaciones. La ruta se conserva solo para no romper bookmarks viejos y redirige a la pantalla
// nueva `/platform/applications`. El guard de scope PLATFORM ya aplicó en el layout padre.
export const Route = createFileRoute('/_authenticated/_layout/platform/tenant-types')({
    beforeLoad: () => {
        throw redirect({ to: '/platform/applications' });
    },
});
